import { Component, Input, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { OnDestroy } from '@angular/core';
import { AppState } from 'src/app/store/app.states';
import { ComponentBase } from 'src/app/views/component-base';
import { commonState_IsSending, commonState_LatestJourney } from 'src/app/store/common/common.selectors';
import { GoToStepAction } from '../../actions';
import { AppButtonComponent, AppReadonlyComponent, EntryCheckboxFieldComponent, EntryFieldComponent, EntryFieldRadioComponent, Helper, NumberEntryFieldComponent } from '@ifaa-components/ui-components';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AsyncPipe, NgFor, NgIf, NgTemplateOutlet } from '@angular/common';
import { SuperannuationProviderSearchComponent } from 'src/app/components/superannuation-provider-search/superannuation-provider-search.component';
import { MatIcon } from '@angular/material/icon';
import { AppButtonDirective } from 'src/app/directives/appbutton.directive';
import { NgrxFormsModule } from 'ngrx-forms';
import { ClearSelectedSearchAction } from 'src/app/components/superannuation-provider-search/actions';
import { AddSuperFundAction, TransferOptionsRequestAction, RemoveSuperFundAction, SelectedProviderAction, ResetFormStateAction } from './actions';
import { rollin_CanAddNewSuperfund, rollin_CanSearch, rollin_Form, rollin_SavedSuperFunds, rollin_SuperFundList, rollin_TransferOptions } from './selectors';
import { distinctUntilChanged } from 'rxjs';

@Component({
    selector: 'app-nmj-rollin',
    templateUrl: './nmj-rollin.component.html',
    styleUrls: ['./nmj-rollin.component.scss'],
    imports: [
        ReactiveFormsModule,
        NgrxFormsModule,
        FormsModule,
        AsyncPipe,
        SuperannuationProviderSearchComponent,
        AppButtonComponent,
        NgIf,
        NumberEntryFieldComponent,
        EntryFieldRadioComponent,
        EntryFieldComponent,
        AppReadonlyComponent,
        MatIcon,
        NgFor,
        NgTemplateOutlet,
        EntryCheckboxFieldComponent,
        AppButtonDirective
    ],
})
export class NmjRollinComponent extends ComponentBase implements OnInit, OnDestroy {

    @Input() set step(value: number) {
        this.stepIndex = value;
    }

    isLoading$ = this.store.pipe(select(commonState_IsSending));
    journeySteps$ = this.store.pipe(select(commonState_LatestJourney));
    form$ = this.store.pipe(select(rollin_Form));
    superFundList$ = this.store.pipe(select(rollin_SuperFundList));

    transferOptions$ = this.store.pipe(select(rollin_TransferOptions));
    savedSuperFunds$ = this.store.pipe(select(rollin_SavedSuperFunds));
    canSearch$ = this.store.pipe(select(rollin_CanSearch));
    canAddNewSuperfund$ = this.store.pipe(select(rollin_CanAddNewSuperfund))

    helper: Helper = new Helper();
    stepIndex: number = 0;
    nextStep: number = 0;
    previousStep: number = 0;

    constructor(public store: Store<AppState>) {
        super();
    }

    async ngOnInit() {
        super.ngOnInitBase();
        window.scrollTo(0, 0);

        this.sub = this.superFundList$
        .pipe(
            distinctUntilChanged((x,y) => JSON.stringify(x) === JSON.stringify(y))
        )
        .subscribe(x => {
            if (x.length === 0){
                this.store.dispatch(AddSuperFundAction());
            }
        })

        this.sub = this.journeySteps$.subscribe(async x => {
            if (x) {
                this.nextStep = (await this.helper.getValue(this.journeySteps$)).journeySteps.filter(x => x.journeyStep > this.stepIndex)[0]?.journeyStep ?? -1;
                this.previousStep = (await this.helper.getValue(this.journeySteps$)).journeySteps.filter(x => x.journeyStep < this.stepIndex).sort((a, b) => b.journeyStep - a.journeyStep)[0].journeyStep;
            }
        })

        this.sub = this.transferOptions$.subscribe(x => {
            if (!x) {
                this.store.dispatch(TransferOptionsRequestAction());
            }
        })
    }

    ngOnDestroy(): void {
        super.ngOnDestroyBase();
    }

    onMoveBackClick() {
        this.store.dispatch(GoToStepAction({ index: this.previousStep }))
    }

    goNext() {
        this.store.dispatch(GoToStepAction({ index: this.nextStep }))
    }

    goNextWithNone() {
        this.store.dispatch(GoToStepAction({ index: this.nextStep }));
        this.store.dispatch(ResetFormStateAction());
    }

    onRemoveSuperFundClick(index: number) {
        this.store.dispatch(RemoveSuperFundAction({ index: index }));
    }

    trackByFn(index, _item) {
        return index;
    }

    onSelectedOption($event: any) {
        this.store.dispatch(
            SelectedProviderAction({
                id: $event.id,
                usi: $event.usi,
                product: $event.productName,
                abn: $event.abn,
                name: $event.name,
            })
        );
    }

    onAddSuperFundClick() {
        this.store.dispatch(AddSuperFundAction());
        this.store.dispatch(ClearSelectedSearchAction());
    }
}
